import FillMethod from './FillMethod'
import Logger from '../Log'
import { ecpmOrDefault } from '../utils'

const Log = Logger.for('JsTagFillMethod')

export default class JsTagFillMethod extends FillMethod {
  constructor (bidder) {
    super(bidder.params.bidder, bidder, 'banner', ecpmOrDefault(bidder.params.ecpm, 0.0001))
  }

  fill (slot, media) {
    return new Promise((resolve, reject) => {
      Log.debug('Returning js tag bid from ' + this.name() + ' at cpm ' + this.estValue())

      resolve({
        ad: this._bidder.params.tag,
        width: null,
        height: null,
        cpm: this.estValue(),
        requestId: 'jstag_' + this._bidder.params.bidder,
        mediaType: 'banner'
      })
    })
  }
}
